import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18next";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as Sentry from '@sentry/react';
import initI18n from "./i18next";
import AppScreenLoader from "./components/AppScreenLoader";
import config from "./utils/config";
const initializeSentry = () => {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DNS,
        integrations: [
            new Sentry.BrowserTracing({
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: JSON.parse(process.env.REACT_APP_SENTRY_TARGET),
            }),
            new Sentry.Replay(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppScreenLoader />);

const startApp = async () => {
    await initI18n();
    document.title = (config && config.brand && config.brand.pageTitle) || 'RPay Payouts';
    try {
        initializeSentry();
    } catch (e) {
        console.log("Couldn't initialize sentry");
    }
    root.render(<App />);
    serviceWorkerRegistration.register();
    // If you want to start measuring performance in your app, pass a function
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}

startApp();